import React, { useState } from "react";
import { styleSelect } from "../../../constants/customStyles";
import Select from 'react-select';
import Toast from "../../../components/Toast";
import { useDispatch, useSelector } from "react-redux";
import { saveLpo } from "../../../actions/LpoActions";

function LpoModal() {

    const dispatch = useDispatch();

    const [claimNo, setClaimNo] = useState('');
    const [date, setDate] = useState('');
    const [value, setValue] = useState('');
    const [excess, setExcess] = useState('');
    const [rebate, setRebate] = useState('');
    const [policyNo, setPolicyNo] = useState('');
    const [type, setType] = useState('');
    const [miscValue, setMiscValue] = useState('');
    const [parts, setParts] = useState('');
    const [repairs, setRepairs] = useState('');
    const [comission, setComission] = useState('');
    const [towing, setTowing] = useState('');
    const [vat, setVat] = useState('');
    const [partsCost, setPartsCost] = useState('');
    const [repairsCost, setRepairsCost] = useState('');
    const [adjustments, setAdjustments] = useState('');

    const save = () => {
        if (claimNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Claim Number is Required!'
            })
        } else if (value.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Value is Required!'
            })
        } else if (excess.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Excess is Required!'
            })
        } else if (date.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Date is Required!'
            })
        } else if (rebate.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Rebate is Required!'
            })
        } else {
            let data = {
                lpo_no: claimNo,
                value: value,
                excess: excess,
                date: date,
                policy_no: policyNo,
                misc_value: miscValue,
                parts: parts,
                repairs: repairs,
                comission: comission,
                towing: towing,
                vat: vat,
                parts_cost: partsCost,
                repairs_cost: repairsCost,
                adjustments: adjustments,
            }
            dispatch(saveLpo(data));
        }
    }

    return (
        <React.Fragment>
            {/* Edit LPO Modal */}
            <div id="lpo-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">LPO</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            <div className="p-2">
                                <ul className="pos__tabs nav nav-pills rounded-2 justify-content-center" role="tablist">
                                    <li id="detail-tab" className="box rounded-3 mx-1 nav-item" role="presentation">
                                        <button className="nav-link w-full pt-2 pb-2.5 active" data-bs-toggle="pill" data-bs-target="#detail" type="button" role="tab" aria-controls="detail-tab" aria-selected="true">Details</button>
                                    </li>
                                    <li id="image-tab" className="box rounded-3 mx-1 nav-item" role="presentation">
                                        <button className="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#image" type="button" role="tab" aria-controls="image-tab" aria-selected="false">Image</button>
                                    </li>
                                </ul>
                            </div>
                            <div className="tab-content mt-5">
                                <div className="tab-pane fade show active" id="detail" role="tabpanel" aria-labelledby="detail-tab">
                                    <form>
                                        <div className="grid columns-12">
                                            {/* <div className="intro-y g-col-6">
                                                <label for="lpo_id" className="form-label"> LPO ID :</label>
                                                <input id="lpo_id" name="lpo_id" type="text" required className="form-control" placeholder="Enter LPO ID" />
                                            </div> */}
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="date" className="form-label">Date :</label>
                                                <div className="input-group mx-auto ">
                                                    <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="date" placeholder="Enter Date" onChange={(e) => setDate(e.target.value)} id="date" name="date" className="datepicker form-control " data-single-mode="true" />
                                                </div>
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="claim_no" className="form-label">Claim No. :</label>
                                                <input id="claim_no" onChange={(e) => setClaimNo(e.target.value)} name="claim_no" type="text" required className="form-control" placeholder="Enter Claim No." />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-12">
                                                <label for="value" className="form-label"> Value :</label>
                                                <input id="value" onChange={(e) => setValue(e.target.value)} name="value" type="text" className="form-control" placeholder="Enter Value" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="excess" className="form-label">Excess :</label>
                                                <input id="excess" onChange={(e) => setExcess(e.target.value)} name="excess" type="text" required className="form-control" placeholder="Enter Excess" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="rebate" className="form-label">Rebate (%) :</label>
                                                <input id="rebate" name="rebate" onChange={(e) => setRebate(e.target.value)} type="text" required className="form-control" placeholder="Enter Rebate" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-12">
                                                <label for="policy_no" className="form-label">Policy No. :</label>
                                                <input id="policy_no" onChange={(e) => setPolicyNo(e.target.value)} name="policy_no" type="text" required className="form-control" placeholder="Enter Policy No." />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="type" className="form-label">Type :</label>
                                                <Select styles={styleSelect} options={[{value : 1 , label: "Third Party" },{value : 2 , label: "Unknown" }]}/>
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="misc_value" className="form-label">Misc Value :</label>
                                                <input id="misc_value" name="misc_value" onChange={(e) => setMiscValue(e.target.value)} type="text" required className="form-control" placeholder="Enter Misc Value" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="parts" className="form-label">Parts :</label>
                                                <input id="parts" name="parts" onChange={(e) => setParts(e.target.value)} type="text" required className="form-control" placeholder="Enter Parts" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="repairs" className="form-label">Repairs :</label>
                                                <input id="repairs" name="repairs" onChange={(e) => setRepairs(e.target.value)} type="text" required className="form-control" placeholder="Enter Repairs" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="comission" className="form-label">Comission :</label>
                                                <input id="comission" name="comission" onChange={(e) => setComission(e.target.value)} type="text" required className="form-control" placeholder="Enter Comission" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="towing" className="form-label">Towing :</label>
                                                <input id="towing" name="towing" type="text" onChange={(e) => setTowing(e.target.value)} required className="form-control" placeholder="Enter Towing" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="vat" className="form-label">VAT :</label>
                                                <input id="vat" name="vat" onChange={(e) => setVat(e.target.value)} type="text" required className="form-control" placeholder="Enter VAT" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="parts_cost" className="form-label">Parts Cost :</label>
                                                <input id="parts_cost" name="parts_cost" onChange={(e) => setPartsCost(e.target.value)} type="text" required className="form-control" placeholder="Enter Parts Cost" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="repair_cost" className="form-label">Repair Cost :</label>
                                                <input id="repair_cost" name="repair_cost" type="text" onChange={(e) => setRepairsCost(e.target.value)} required className="form-control" placeholder="Enter Repair Cost" />
                                            </div>
                                            <div className="intro-y g-col-12 g-col-sm-6">
                                                <label for="adjustment" className="form-label">Adjustments :</label>
                                                <input id="adjustment" name="adjustment" type="text" onChange={(e) => setAdjustments(e.target.value)} required className="form-control" placeholder="Enter Adjustments" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="tab-pane fade show" id="image" role="tabpanel" aria-labelledby="image-tab">
                                    <div className="intro-y g-col-12">
                                        <label for="image" className="form-label">Image:</label>
                                        <div className="dropzone text-center pt-10">
                                            <div className="fallback ms-5"> <input name="file" type="file" multiple /> </div>
                                            <div className="dz-message mt-3" data-dz-message>
                                                <div className="fs-lg fw-medium">Drop files here or click to upload.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div className="modal-footer text-end">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button>
                            <button onClick={save} data-bs-dismiss="modal" type="button" className="btn btn-primary w-20">Submit</button> </div>
                    </div>
                </div>
            </div>
            {/*End Edit LPO Modal */}
        </React.Fragment>
    )
}

export default LpoModal;